import { render, staticRenderFns } from "./code-simple.vue?vue&type=template&id=13056643&"
import script from "./code-simple.vue?vue&type=script&lang=js&"
export * from "./code-simple.vue?vue&type=script&lang=js&"
import style0 from "./code-simple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports